export default {
  data () {
    return {
      permissionButtons: []
    }
  },
  created () {
    this.getButtons()
  },
  methods: {
    getButtons () {
      let matched = this.$route.matched.filter(item => item.name)
      const code = matched[0]
      this.$store.dispatch('getBtnByMenu', {code: code.path}).then(res => {
        this.permissionButtons = res
        console.log(this.permissionButtons)
      })
      // if (code && code.name) {
      //   // TODO 请求加载按钮
      //   this.permissionButtons = [
      //     {code: 'edit', name: '修改' , icon: 'edit'},
      //     {code: 'add', name: '新增' , icon: 'add'}
      //   ]
      // }
    },
    btnClick (code) {
      this.$emit('click', code)
    }
  }
}
